module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.85e92f90.ttf";